<stx-authentication-container>
  <h1>
    @if (isTranslated) {
    {{ message | translate }}
    } @if (!isTranslated) {
    {{ message }}
    }
  </h1>
</stx-authentication-container>
